import { EventsAction, IBody, IComponentBehavior } from '@makyoapp/makyo-sdk/models/AppBuilder'

import { IAppLayer } from './layer'

type Subscriber = (key: string) => void

export interface IViewComponent {
  /**
   * The page/overlay that contains this component
   */
  container: IAppLayer
  /**
   * Main component properties
   */
  _id: string
  _Title: string
  _ComponentID: string
  _GroupID: string
  _Actions: EventsAction
  _Behavior: IComponentBehavior
  _Removable: boolean
  _Draggable: boolean
  _IsSubmit: boolean
  _Body: IBody[]
  /**
   * Parent component id
   */
  parentId?: string
  /**
   * Component settings
   */
  settings: Record<string, any>
  /**
   * Subscriber for each component
   */
  subscribers: Set<Subscriber>
  /**
   * Subscribe to page update
   */
  subscribe(callback: Subscriber): () => void
  /**
   * Convert to SDK body
   */
  toBody(): IBody
  /**
   * Rename component
   */
  Rename(newTitle: string): void
  /**
   *
   */
  Update(body: Partial<IBody>, settings?: Record<string, any>): void
  /**
   *
   */
  UpdateSettings(settingKey: string, updatedValue: any): void
  /**
   *
   */
  UpdateAllSettings(settings: Record<string, any>): void
}

export class ViewComponent implements IViewComponent {
  container: IAppLayer
  _id: string
  _Title: string
  _ComponentID: string
  _GroupID: string
  _Actions: EventsAction
  _Behavior: IComponentBehavior
  _Removable: boolean
  _Draggable: boolean
  _IsSubmit: boolean
  _Body: IBody[]

  settings: Record<string, any> = {}
  parentId?: string

  subscribers: Set<Subscriber> = new Set()

  constructor(container: IAppLayer, body: IBody, parentId?: string) {
    this.container = container

    if (parentId) {
      this.parentId = parentId
    }

    this._id = body._id
    this._Title = body._Title
    this._ComponentID = body._ComponentID
    this._GroupID = body._GroupID
    this._Actions = body._Actions
    this._Behavior = body._Behavior
    this._Removable = body._Removable
    this._Draggable = body._Draggable
    this._IsSubmit = body._IsSubmit
    this._Body = body._Body

    this.settings = container.settings._BodySettings?.[body._id] || {}
  }

  public subscribe(callback: Subscriber): () => void {
    this.subscribers.add(callback)
    return () => {
      this.subscribers.delete(callback)
    }
  }

  private notifySubscribers(key: string): void {
    this.subscribers.forEach((callback) => callback(key))
  }

  toBody(): IBody {
    return {
      _id: this._id,
      _Title: this._Title,
      _ComponentID: this._ComponentID,
      _GroupID: this._GroupID,
      _Actions: this._Actions,
      _Behavior: this._Behavior,
      _Removable: this._Removable,
      _Draggable: this._Draggable,
      _IsSubmit: this._IsSubmit,
      _Body: this._Body,
    }
  }

  Rename(newTitle: string) {
    this._Title = newTitle
    if (this._ComponentID === 'tab-item') {
      this.settings.title = newTitle
    }
    this.container.UpdateComponent(this)
  }

  Update(body: Partial<IBody>, settings?: Record<string, any>) {
    Object.assign(this, body)

    if (settings) {
      this.settings = settings
    }
    this.container.UpdateComponent(this)
  }

  UpdateSettings(settingKey: string, updatedValue: any) {
    if (!this.settings) return

    this.settings = {
      ...this.settings,
      [settingKey]: updatedValue,
    }

    this.notifySubscribers(settingKey)
    this.container.UpdateComponentSettings(this)
  }

  UpdateAllSettings(updatedSettings: Record<string, any>) {
    this.settings = { ...updatedSettings }
    if (this._ComponentID === 'tab-item' && this._Title !== updatedSettings.title) {
      this._Title = updatedSettings.title
    }
    this.notifySubscribers('all')
    this.container.UpdateComponent(this)
  }
}
